import { Component } from '@angular/core';
import { RiskConceptsComponent } from '../risk-concepts/risk-concepts.component';
@Component({selector:'app-transaction-log',standalone:true,imports:[RiskConceptsComponent],template:'<app-risk-concepts [page]="5"></app-risk-concepts>'})
export class TransactionLogComponent {}
